/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getNotificationPreferences.defs'
export { main as default } from './getNotificationPreferences.defs'
